import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import HeaderNotHome from "../Components/Header/HeaderNotHome";
import SaveComponent from "../Components/Save/Save";

function Save() {
    return (
        <>
        <HeaderNotHome />
        <SaveComponent />
        </>
      );
}

export default Save;